import { Controller } from "@hotwired/stimulus";

// Suit l'avancement d'un lot d'identifiants : interroge l'état tant que la
// tâche de fond tourne, met à jour la barre et les compteurs, puis recharge la
// page à la fin pour afficher les téléchargements.
export default class extends Controller {
  static targets = ["bar", "percent", "processed"];
  static values = { url: String, interval: { type: Number, default: 2000 } };

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" });
      if (!response.ok) return;
      const data = await response.json();
      if (this.hasBarTarget) this.barTarget.style.width = `${data.progress}%`;
      if (this.hasPercentTarget) this.percentTarget.textContent = `${data.progress} %`;
      if (this.hasProcessedTarget) this.processedTarget.textContent = `${data.processed} / ${data.total}`;
      if (data.finished) {
        clearInterval(this.timer);
        window.location.reload();
      }
    } catch (error) {
      // Réseau coupé : on réessaiera au prochain tour.
    }
  }
}
